import { useNotify, useDataProvider } from 'react-admin';
import { useEffect, useState } from "react";
import InputFieldCustom from '../Commons/InputFieldCustom'
import AccountPicker from '../Commons/AccountPicker'
import { useMediaQuery } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Validate from '../Commons/Validate';
import CircularProgress from '@mui/material/CircularProgress';
import BreadCrumbCustom from '../Commons/BreadCrum';
import historyTracker from '../Commons/historyTracker';
import { useNavigate, useLocation } from 'react-router-dom';
import { Style } from '../Commons/Styles.jsx';
import BottomToolBar from '../Commons/BottomToolBar';
import AuthNotification from '../Commons/AuthNotification';
import InternalMenu from '../Commons/InternalMenu';
// TODO: reemplazar por el ícono definitivo de Proveedores cuando esté disponible
import providers from '../Commons/Icons/apps.svg';
import providerList from '../Commons/Icons/book.svg';

import { hasPermissions } from '../Commons/CompanyAuth';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// asistelibros (char(2)) NO es un SI/NO como se penso en un primer analisis: el trigger
// trinscbfacturaintegcontable.sql exige que nunca sea null ("Error, debe seleccionar un
// bien o Servicio") y sp_libro_de_compras.sql / sp_cbasiste_libros.sql confirman que es
// una clasificacion de 3 valores fijos usada para el Libro de Compras (SAT): 'BA' (Bien
// Adquirido), 'SA' (Servicio Adquirido) e 'IP' (Combustible). No tiene catalogo de BD
// propio, es un catalogo fijo igual que InvoiceTypes en ProviderInvoiceCreate.jsx, pero
// a diferencia de ese es obligatorio, no tiene opcion "Ninguno".
const BooksFlagOptions = [
    { key: 'BA', value: 'Bien Adquirido' },
    { key: 'SA', value: 'Servicio Adquirido' },
    { key: 'IP', value: 'Combustible' },
];

// La factura (corre_facturacion) llega desde AccountingExpensesList por query string
// (?invoice=...&invoiceNumber=...), no por location.state: el correlativo nunca se
// muestra en este formulario, solo se manda al crear.
const getInvoice = (location) => {
    try {
        const params = new URLSearchParams(location?.search || '');
        const fromQuery = params.get('invoice');
        if (fromQuery) return fromQuery;
    } catch {
        // sigue al respaldo de abajo
    }
    return location?.state?.invoiceId || null;
};

const getInvoiceNumber = (location) => {
    try {
        const params = new URLSearchParams(location?.search || '');
        const fromQuery = params.get('invoiceNumber');
        if (fromQuery) return fromQuery;
    } catch {
        // sigue al respaldo de abajo
    }
    return location?.state?.invoiceNumber || null;
};

const AccountingExpenseCreate = (props) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const location = useLocation();
    const invoiceId = getInvoice(location);
    const invoiceNumber = getInvoiceNumber(location);

    const [costCenter, setCostCenter] = useState('');
    const [costCenters, setCostCenters] = useState([]);
    const [account, setAccount] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [allAccounts, setAllAccounts] = useState([]);
    const [hasAuxiliary, setHasAuxiliary] = useState(false);
    const [auxiliaryCode, setAuxiliaryCode] = useState('');
    const [auxiliaries, setAuxiliaries] = useState([]);
    const [auxiliaryDescription, setAuxiliaryDescription] = useState('');
    const [amount, setAmount] = useState('0.00');
    const [vatExemptAmount, setVatExemptAmount] = useState('0.00');
    const [isrExemptAmount, setIsrExemptAmount] = useState('0.00');
    const [isrCode, setIsrCode] = useState('');
    const [isrConcepts, setIsrConcepts] = useState([]);
    // Requerido (ver nota en BooksFlagOptions): arranca en la primera opcion para que el
    // <select> nativo y el estado queden sincronizados desde el primer render.
    const [booksFlag, setBooksFlag] = useState(BooksFlagOptions[0].key);
    const [invoiceAmount, setInvoiceAmount] = useState(null);
    const [registeredAmount, setRegisteredAmount] = useState(0);

    const [openerror, setOpenerror] = useState(false);
    const [message, setMessage] = useState('');
    const [opacity, setOpacity] = useState(1);
    const [displayLoading, setDisplayLoading] = useState('none');
    const [disable, setDisable] = useState(false);
    const [openAuth, setOpenAuth] = useState(false);
    const [auth, setAuth] = useState(false);
    // Mientras esto es true se muestra el spinner de carga inicial (ver el bloque
    // "initialLoading" en el return): esta pantalla necesita traer permisos, centros,
    // cuentas, conceptos ISR y el monto de la factura antes de poder mostrar el
    // formulario, y sin este estado la ventana se veia en blanco (solo el breadcrumb)
    // durante esa espera.
    const [initialLoading, setInitialLoading] = useState(true);
    const dataProvider = useDataProvider();

    const notify = useNotify();

    const handleClickError = () => {
        setOpenerror(true);
    };

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenerror(false);
    };

    useEffect(() => {
        (async () => {
            try {
                const currentPath = location.pathname;
                historyTracker.addPath(currentPath, invoiceNumber ? `Crear Gasto Contable - Factura ${invoiceNumber}` : 'Crear Gasto Contable', 7);

                const authdata = { data: hasPermissions('AccountingExpense', 'create') };
                if (authdata.data.length > 0) {
                    setAuth(authdata.data[0]);
                    setOpenAuth(!authdata.data[0]);

                    if (authdata.data[0]) {
                        const [centersData, accountsData, isrConceptsData, invoiceData, existingExpensesData, existingIntegrationsData] = await Promise.all([
                            dataProvider.getList('provider/centers', { filter: {}, pagination: {}, sort: {} }),
                            dataProvider.getList('provider/accounts', { filter: {}, pagination: {}, sort: {} }),
                            dataProvider.getList('provider/isrconcepts', { filter: {}, pagination: {}, sort: {} }),
                            // Monto total de la factura y lo que ya se registro en ella, para poder
                            // validar que este gasto (pueden ser varios parciales) nunca haga que la
                            // suma supere el monto de la factura (ver PostAccountingExpense). Se trae
                            // tanto gastos contables como integraciones de inventario ya registradas:
                            // cbfactura.montointegraciongasto y montointegracioninventarios son
                            // columnas separadas en BD, pero ambas restan del MISMO monto de la
                            // factura, asi que si ya hay integraciones de inventario creadas, el saldo
                            // pendiente para un gasto contable nuevo debe reflejarlo tambien.
                            dataProvider.getOne('provider/invoice', { id: invoiceId }),
                            dataProvider.getList('provider/accountingexpense', { filter: { invoice: invoiceId }, pagination: {}, sort: {} }),
                            dataProvider.getList('provider/inventoryintegration', { filter: { invoice: invoiceId }, pagination: {}, sort: {} }),
                        ]);

                        var costCentersList = centersData.data.map(item => ({ key: item.code, value: `${item.code} - ${item.description}` }));
                        setCostCenters([{ key: '', value: 'Seleccione' }, ...costCentersList]);

                        // El catalogo de cuentas viene con "center" (cod_centro) por fila, porque
                        // nomenclatura_cuentas liga cada cuenta a un centro puntual (ver analisis de
                        // sp_devuelve_catalogo_cuentas): se guarda completo y se filtra por centro
                        // elegido mas abajo, en vez de mostrar todas las cuentas de una vez.
                        setAllAccounts(accountsData.data);

                        // Concepto ISR: si hay uno marcado "default" (mismo que autoasigna el propio
                        // SP cuando @codigoisr llega null), se preselecciona para que coincida con lo
                        // que haria el SP si se dejara vacio.
                        var isrConceptsList = isrConceptsData.data.map(item => ({ key: item.id, value: item.name }));
                        setIsrConcepts([{ key: '', value: 'Ninguno' }, ...isrConceptsList]);
                        var defaultIsrConcept = isrConceptsData.data.find(item => item.default);
                        if (defaultIsrConcept)
                            setIsrCode(defaultIsrConcept.id);

                        setInvoiceAmount(invoiceData.data.invoiceAmount);
                        var alreadyRegisteredExpenses = existingExpensesData.data.reduce((total, item) => total + parseFloat(item.amount || 0), 0);
                        var alreadyRegisteredIntegrations = existingIntegrationsData.data.reduce((total, item) => total + parseFloat(item.amount || 0), 0);
                        setRegisteredAmount(alreadyRegisteredExpenses + alreadyRegisteredIntegrations);
                    }
                } else {
                    setAuth(false);
                    setOpenAuth(true)
                }
            }
            catch {
            }
            finally {
                setInitialLoading(false);
            }
        })();
    }, [dataProvider, location.pathname, invoiceId, invoiceNumber]);

    // La cuenta solo puede elegirse entre las que pertenecen al centro seleccionado
    // (ver nota sobre nomenclatura_cuentas arriba). Al cambiar de centro se recalcula la
    // lista y se limpia la cuenta elegida si ya no pertenece al nuevo centro.
    useEffect(() => {
        if (!costCenter) {
            setAccounts([]);
            setAccount('');
            return;
        }

        var filtered = allAccounts.filter(item => item.center === costCenter);
        var accountsList = filtered.map(item => ({ key: item.account, value: `${item.account} - ${item.name}` }));
        setAccounts([{ key: '', value: 'Seleccione' }, ...accountsList]);
        if (!filtered.some(item => item.account === account)) {
            setAccount('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [costCenter, allAccounts]);

    // El combo de Auxiliar solo aplica a cuentas que lo requieren (posee_auxiliar = 'S' en
    // sp_devuelve_catalogo_cuentas, expuesto como hasAuxiliary). Es un catalogo dependiente:
    // se vuelve a pedir cada vez que cambia la cuenta elegida.
    useEffect(() => {
        (async () => {
            var selected = allAccounts.find(item => item.center === costCenter && item.account === account);
            var requiresAuxiliary = !!selected?.hasAuxiliary;
            setHasAuxiliary(requiresAuxiliary);

            if (!requiresAuxiliary) {
                setAuxiliaries([]);
                setAuxiliaryCode('');
                return;
            }

            try {
                const { data } = await dataProvider.getList('provider/auxiliaries', { filter: { account }, pagination: {}, sort: {} });
                var auxiliariesList = data.map(item => ({ key: item.id, value: item.name }));
                setAuxiliaries([{ key: '', value: 'Ninguno' }, ...auxiliariesList]);
            } catch {
                setAuxiliaries([]);
            }
        })();
    }, [account, costCenter, allAccounts, dataProvider]);

    // Intercepta CADA llamada a setValue que hace InputFieldCustom para el campo Monto, no
    // solo la del tecleo: cuando "money" esta activo, InputFieldCustom llama setValue dos
    // veces por cada cambio -- una vez de inmediato con el texto crudo, y otra vez ~500ms
    // despues (su propio debounce interno) ya con el monto reformateado (con comas/
    // decimales). Antes esto se validaba con un useEffect que miraba el estado "amount", y
    // el problema era que la llamada tardia reformateada llegaba DESPUES del reset a 0.00,
    // pisandolo y dejando otra vez el monto invalido. Al interceptar en el setter mismo, las
    // dos llamadas (la del tecleo y la del reformateo) pasan por la misma validacion, asi
    // que ninguna puede sobreescribir el reset. "saldo pendiente" es invoiceAmount menos lo
    // ya registrado (registeredAmount), NO el monto total de la factura solo.
    const setAmountGuarded = (rawValue) => {
        var enteredAmount = parseFloat(String(rawValue).replace(/[^0-9.-]/g, '')) || 0;
        var remainingAmount = invoiceAmount === null ? null : (parseFloat(invoiceAmount) - registeredAmount);
        if (remainingAmount !== null && enteredAmount > remainingAmount + 0.005) {
            // Se deja el campo en el saldo pendiente (el maximo permitido) en vez de en 0.00,
            // para que quede claro cual es el limite en vez de simplemente vaciar el campo.
            notify(`El monto (Q ${enteredAmount.toFixed(2)}) supera el saldo pendiente por registrar de la factura (Q ${remainingAmount.toFixed(2)}). Se ajustó al máximo disponible.`, { type: 'warning' });
            setAmount(Math.max(remainingAmount, 0).toFixed(2));
            return;
        }
        setAmount(rawValue);
    };

    // Si el monto BAJA despues de que ya se capturo un no-afecto de IVA/ISR (p.ej. el usuario
    // lo edita directamente, o setAmountGuarded lo recorta al saldo pendiente de la factura),
    // los guards de los campos de no-afecto (mas abajo) no se enteran porque solo corren
    // cuando se escribe EN ESOS campos, no cuando cambia el monto. Este efecto reacciona a
    // cada cambio de "amount" y recorta vatExemptAmount/isrExemptAmount si quedaron por encima
    // del nuevo monto. Usa la forma funcional de setState (prev => ...) para no depender de
    // vatExemptAmount/isrExemptAmount en el arreglo de dependencias: si se agregaran ahi, el
    // efecto se volveria a disparar cada vez que estos mismos setters lo cambian, generando un
    // ciclo de re-ejecuciones innecesario.
    useEffect(() => {
        var amountLimit = parseFloat(amount.toString().replace(/[^0-9.-]/g, '')) || 0;

        setVatExemptAmount(prev => {
            var enteredVat = parseFloat(String(prev).replace(/[^0-9.-]/g, '')) || 0;
            if (enteredVat > amountLimit + 0.005) {
                notify(`El monto no afecto a IVA (Q ${enteredVat.toFixed(2)}) supera el nuevo monto (Q ${amountLimit.toFixed(2)}). Se ajustó al máximo disponible.`, { type: 'warning' });
                return amountLimit.toFixed(2);
            }
            return prev;
        });

        setIsrExemptAmount(prev => {
            var enteredIsr = parseFloat(String(prev).replace(/[^0-9.-]/g, '')) || 0;
            if (enteredIsr > amountLimit + 0.005) {
                notify(`El monto no afecto a ISR (Q ${enteredIsr.toFixed(2)}) supera el nuevo monto (Q ${amountLimit.toFixed(2)}). Se ajustó al máximo disponible.`, { type: 'warning' });
                return amountLimit.toFixed(2);
            }
            return prev;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [amount]);

    // Monto No Afecto IVA / ISR son porciones DEL monto (la parte del monto que no esta afecta
    // a cada impuesto), asi que ninguno de los dos puede ser mayor que el monto mismo. Mismo
    // patron de "avisar y ajustar al maximo permitido" que setAmountGuarded, pero el limite aca
    // es el monto capturado arriba, no el saldo de la factura.
    const setVatExemptAmountGuarded = (rawValue) => {
        var enteredAmount = parseFloat(String(rawValue).replace(/[^0-9.-]/g, '')) || 0;
        var amountLimit = parseFloat(amount.toString().replace(/[^0-9.-]/g, '')) || 0;
        if (enteredAmount > amountLimit + 0.005) {
            notify(`El monto no afecto a IVA (Q ${enteredAmount.toFixed(2)}) no puede ser mayor al monto (Q ${amountLimit.toFixed(2)}). Se ajustó al máximo disponible.`, { type: 'warning' });
            setVatExemptAmount(amountLimit.toFixed(2));
            return;
        }
        setVatExemptAmount(rawValue);
    };

    const setIsrExemptAmountGuarded = (rawValue) => {
        var enteredAmount = parseFloat(String(rawValue).replace(/[^0-9.-]/g, '')) || 0;
        var amountLimit = parseFloat(amount.toString().replace(/[^0-9.-]/g, '')) || 0;
        if (enteredAmount > amountLimit + 0.005) {
            notify(`El monto no afecto a ISR (Q ${enteredAmount.toFixed(2)}) no puede ser mayor al monto (Q ${amountLimit.toFixed(2)}). Se ajustó al máximo disponible.`, { type: 'warning' });
            setIsrExemptAmount(amountLimit.toFixed(2));
            return;
        }
        setIsrExemptAmount(rawValue);
    };

    const PostAccountingExpense = async () => {
        let control = 0;

        if (!invoiceId) {
            setMessage("No se pudo determinar la factura de este gasto contable");
            handleClickError();
            return;
        }

        if (!Validate(costCenter, { required: true }))
            control++;

        if (!Validate(account, { required: true }))
            control++;

        if (!Validate(amount, { money: true, required: true }))
            control++;

        if (!Validate(booksFlag, { required: true }))
            control++;

        if (control > 0) {
            setMessage("No se pudo crear el Gasto Contable");
            handleClickError();
            return;
        }

        // Se pueden crear varios gastos contables parciales sobre la misma factura (el
        // trigger de BD va acumulando cbfactura.montointegraciongasto con cada uno), pero
        // ninguno de ellos debe hacer que la suma supere el monto de la factura. La BD no
        // valida esto (el trigger solo exige monto > 0), asi que se valida aca antes de
        // enviar a crear.
        var enteredAmount = parseFloat(amount.toString().replace(/[^0-9.-]/g, '')) || 0;
        var remainingAmount = invoiceAmount === null ? null : (parseFloat(invoiceAmount) - registeredAmount);
        if (remainingAmount !== null && enteredAmount > remainingAmount + 0.005) {
            setMessage(`El monto (Q ${enteredAmount.toFixed(2)}) supera lo que falta por registrar de la factura (Q ${remainingAmount.toFixed(2)}).`);
            handleClickError();
            return;
        }

        // Re-chequeo de seguridad: setVatExemptAmountGuarded/setIsrExemptAmountGuarded ya
        // impiden capturar un valor mayor al monto, pero el monto puede haber bajado DESPUES
        // (p.ej. setAmountGuarded lo ajusto al saldo pendiente), dejando un no-afecto que ya
        // no es valido para el nuevo monto.
        var enteredVatExempt = parseFloat(vatExemptAmount.toString().replace(/[^0-9.-]/g, '')) || 0;
        var enteredIsrExempt = parseFloat(isrExemptAmount.toString().replace(/[^0-9.-]/g, '')) || 0;
        if (enteredVatExempt > enteredAmount + 0.005 || enteredIsrExempt > enteredAmount + 0.005) {
            setMessage(`El monto no afecto a IVA/ISR no puede ser mayor al monto (Q ${enteredAmount.toFixed(2)}).`);
            handleClickError();
            return;
        }

        setOpacity(0.3);
        setDisable(true);
        setDisplayLoading('block');

        var info = {
            invoice: invoiceId,
            costCenter,
            account,
            amount: amount.toString().replace(/[^0-9.-]/g, ''),
            vatExemptAmount: vatExemptAmount.toString().replace(/[^0-9.-]/g, ''),
            isrExemptAmount: isrExemptAmount.toString().replace(/[^0-9.-]/g, ''),
            auxiliaryCode: hasAuxiliary ? (auxiliaryCode || null) : null,
            auxiliaryDescription: hasAuxiliary ? (auxiliaryDescription || null) : null,
            isrCode: isrCode || null,
            booksFlag: booksFlag || null,
        }

        dataProvider.create('provider/accountingexpense', { data: info })
            .then(() => {
                setOpacity(1);
                setDisable(false);
                setDisplayLoading('none');
                notify('Gasto Contable creado correctamente');
                navigate({
                    pathname: '/provider/accountingexpense',
                    search: `?filter=${encodeURIComponent(JSON.stringify({ invoice: invoiceId }))}&invoiceNumber=${encodeURIComponent(invoiceNumber || '')}`,
                }, { state: { invoiceNumber, invoiceId } });
            })
            .catch((error) => {
                setOpacity(1);
                setDisable(false);
                setDisplayLoading('none');
                setMessage("No se pudo crear el Gasto Contable. " + error.toString().replace('HttpError: ', ''));
                handleClickError()
            })
    }

    const handleRedirectProviderList = () => {
        navigate(`/provider`);
    };

    const handleRedirectExpenses = () => {
        navigate({
            pathname: '/provider/accountingexpense',
            search: `?filter=${encodeURIComponent(JSON.stringify({ invoice: invoiceId }))}&invoiceNumber=${encodeURIComponent(invoiceNumber || '')}`,
        }, { state: { invoiceNumber, invoiceId } });
    };

    const [openProviders, setOpenProviders] = useState(true);

    const handleClickOpenProviders = () => {
        setOpenProviders(!openProviders);
    };

    const menus = [{
        icon: <img src={providers} alt="logo" style={Style.MenuLogo} />, name: 'Proveedores',
        open: openProviders,
        openAction: handleClickOpenProviders,
        actions: [
            { icon: <img src={providerList} alt="logo" style={Style.MenuLogo} />, name: 'Listado', onClick: handleRedirectProviderList },
        ]
    }];

    return (
        <div class="container">
            <BreadCrumbCustom history={historyTracker.getHistory()} />
            {initialLoading ? (
                // Spinner de carga inicial: reutiliza la misma clase "Loading" (index.css) y
                // el mismo CircularProgress que ya se usaba para el guardado (mas abajo,
                // controlado por displayLoading), pero aqui cubre la espera de auth + centros +
                // cuentas + rubros + conceptos ISR + monto de la factura, que antes dejaba la
                // pantalla en blanco.
                <div class="Loading" style={{ display: 'block' }}>
                    <CircularProgress size="15rem" />
                </div>
            ) : auth ? (
                // paddingBottom en linea recorta el padding-bottom:2em fijo que trae la clase
                // "edit" (index.css) solo para esta pantalla -- el formulario es corto (2-3
                // filas) y con el padding de 2em completo mas el marginTop de arriba, quedaba
                // mucho mas aire abajo del boton que arriba. No se toco la clase "edit" en si
                // porque la comparten todas las pantallas de Crear/Show.
                <div class="edit" style={{ paddingBottom: '0.1em' }}>
                    {!isSmall ? (
                        <div class="Loading" style={{ display: displayLoading }}>
                            <CircularProgress size="15rem" />
                        </div>) : (
                        <div class="Loading" style={{ display: displayLoading }}>
                            <CircularProgress size="15rem" />
                        </div>
                    )}
                    {!isSmall ? (
                        <div class="container" style={{ opacity: opacity }}>
                            {invoiceAmount !== null ? (
                                <div class="row">
                                    <div class="col-12">
                                        <label style={Style.Label}>
                                            Saldo pendiente por registrar: Q {(parseFloat(invoiceAmount) - registeredAmount).toLocaleString('es-GT', { style: 'decimal', minimumFractionDigits: 2 })} de Q {parseFloat(invoiceAmount).toLocaleString('es-GT', { style: 'decimal', minimumFractionDigits: 2 })}
                                        </label>
                                    </div>
                                </div>
                            ) : null}
                            <div class="row">
                                <InputFieldCustom col="col-3" width='95%' setValue={setCostCenter} value={costCenter} options={costCenters} component="select" label="Centro *" />
                                {/* Antes era un <select> plano con las cuentas del Centro de Costo elegido.
                                    Ahora es un campo de solo lectura (component="search", mismo patron ya
                                    usado para Cliente/Inmueble en DownPaymentsGeneral/DownPaymentCreate.jsx)
                                    con una lupa al costado que abre una ventana flotante para buscar por
                                    codigo o nombre y elegir con un click -- ver Commons/AccountPicker.jsx.
                                    Sigue usando el mismo estado (account/setAccount) y el mismo array ya
                                    filtrado por Centro de Costo (accounts), asi que el resto de la pantalla
                                    (payload, useEffect de Auxiliar, etc.) no cambia. */}
                                <InputFieldCustom
                                    col="col-3"
                                    width='95%'
                                    value={accounts.find((item) => item.key === account)?.value || ''}
                                    readOnly
                                    component="search"
                                    label="Cuenta *"
                                    search={<AccountPicker accounts={accounts} onSelect={setAccount} disabled={!costCenter || accounts.length <= 1} />}
                                />
                                <InputFieldCustom value={amount} setValue={setAmountGuarded} col="col-3" width="95%" placeholder="Ingresa el monto" label="Monto (Q) *" required type="text" money />
                            </div>
                            <div class="row">
                                <InputFieldCustom value={vatExemptAmount} setValue={setVatExemptAmountGuarded} col="col-3" width="95%" placeholder="Ingresa el monto" label="Monto No Afecto IVA (Q)" type="text" money />
                                <InputFieldCustom value={isrExemptAmount} setValue={setIsrExemptAmountGuarded} col="col-3" width="95%" placeholder="Ingresa el monto" label="Monto No Afecto ISR (Q)" type="text" money />
                                <InputFieldCustom col="col-3" width='95%' setValue={setIsrCode} value={isrCode} options={isrConcepts} component="select" label="Concepto Retención ISR" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setBooksFlag} value={booksFlag} options={BooksFlagOptions} component="select" label="Clasificación *" />
                            </div>
                            {hasAuxiliary ? (
                                <div class="row">
                                    <InputFieldCustom col="col-3" width='95%' setValue={setAuxiliaryCode} value={auxiliaryCode} options={auxiliaries} component="select" label="Auxiliar" />
                                    <InputFieldCustom value={auxiliaryDescription} setValue={setAuxiliaryDescription} col="col-3" width="95%" placeholder="Ingresa la descripción" label="Descripción Auxiliar" type="text" />
                                </div>
                            ) : null}
                            {/* Espacio extra antes del boton (ademas del marginTop propio de
                                BottomToolBar) para que no quede pegado a la ultima fila del
                                formulario, igual que el boton en ProvidersShow/las pantallas
                                de "Show". Antes este Create no lo tenia, a diferencia de esas. */}
                            <div style={{ marginTop: '2em' }}>
                                <BottomToolBar buttons={[{ auth: true, action: PostAccountingExpense, name: 'Crear' }, { auth: true, action: handleRedirectExpenses, name: 'Cancelar' }]} disabled={disable} menu={<InternalMenu menus={menus} />} />
                            </div>
                        </div>
                    ) : (
                        <div class="container" style={{ opacity: opacity }}>

                        </div>)
                    }
                    <div class="row" style={Style.Alert}>
                        <div>
                            <Snackbar open={openerror} autoHideDuration={4000} onClose={handleCloseError}>
                                <div>
                                    <Alert onClose={handleCloseError} severity="error" style={Style.AlertMessage} >
                                        {message}
                                    </Alert>
                                </div>
                            </Snackbar>
                        </div>
                    </div>
                </div>) : (<AuthNotification openerror={openAuth} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)}
        </div>
    )
}

export default AccountingExpenseCreate
